<ng-container *ngIf="dataForFlowlines$ | async as dataForFlowlines">
  <div class="connector-menu">
    <div *ngIf="dataForFlowlines.loadingLinks; else linksTemplate" class="connector-menu__no-link">
      <mat-progress-spinner [mode]="'indeterminate'" [diameter]="16"></mat-progress-spinner>
      <span class="connector-menu__no-link-text">
        {{ 'CONNECTOR.LOADING' | translate }}
      </span>
    </div>

    <ng-template #linksTemplate>
      <div *ngIf="!dataForFlowlines.links?.length" class="connector-menu__no-link">
        <span class="empty-message">
          {{ 'CONNECTOR.EMPTY_LIST' | translate }}
        </span>
      </div>

      <div *ngFor="let link of dataForFlowlines.links; trackBy: trackLinksById" class="links">
        <a
          class="connector-menu__link"
          [href]="'/diagram/' + link.diagramId + '?v=' + version"
          *q9Screenshot="getConfigForScreen(link.diagramId)"
          (click)="navigate(link, $event)">
          <span
            [translate]="'CONNECTOR.LINK'"
            [translateParams]="{
              diagramName: link.diagramName | decodeHtml,
              levelNumber: link.diagramLevelNumber,
              mapName: link.mapName | decodeHtml
            }"></span>
        </a>
        <q9-icon-button
          *ngIf="dataForFlowlines.isEditMode"
          icon="close"
          (click)="disconnect(link.connectorId)"></q9-icon-button>
      </div>
    </ng-template>
  </div>
</ng-container>
